const toNumberFormat = (value) => {
    if (typeof value !== 'number') {
        return value;
    }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export default toNumberFormat;
